var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FieldItem",
    { attrs: { id: _vm.id, label: _vm.$t(_vm.fieldConfig.label) } },
    [
      _c("div", { staticClass: "common-range-group" }, [
        _c("div", { staticClass: "common-range-group__input" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.fieldValue[0],
                expression: "fieldValue[0]",
              },
            ],
            staticStyle: { "text-align": "right" },
            attrs: { maxlength: 9, type: "text" },
            domProps: { value: _vm.fieldValue[0] },
            on: {
              keypress: function ($event) {
                return _vm.isNumber($event)
              },
              blur: _vm.syncChange,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.fieldValue, 0, $event.target.value)
              },
            },
          }),
        ]),
        _c("div", { staticClass: "common-range-group__separator" }),
        _c("div", { staticClass: "common-range-group__input" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.fieldValue[1],
                expression: "fieldValue[1]",
              },
            ],
            staticStyle: { "text-align": "left" },
            attrs: { maxlength: 9, placeholder: "∞", type: "text" },
            domProps: { value: _vm.fieldValue[1] },
            on: {
              keypress: function ($event) {
                return _vm.isNumber($event)
              },
              blur: _vm.syncChange,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.fieldValue, 1, $event.target.value)
              },
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }